import { v4 as uuidv4 } from 'uuid';
import React, { useEffect, useState } from "react";
import { chat_boat_icon, profiledrop } from "../../assets/icons";
import { Button, Input } from "../form";
import { RxCross2 } from "react-icons/rx";
import { PublicService } from "../../services";
import { useMutation, useQuery } from "@tanstack/react-query";
import useSnackbar from "../../hooks/useSnackbar";
import { chat_user } from "../../assets/images";

const ChatBoat = () => {
  const { getOpenAiPrompt } = PublicService();
  const [text, setText] = useState("");
  const { snackbar } = useSnackbar();
  const [messages, setMessages] = useState([]);
  const [showChatBoat, setShowChatBoat] = useState(false);

  const openAiMutation = useMutation({
    mutationFn: () => {
      const uuid = localStorage.getItem("hollyPills_uuid");

      setText("");
      setMessages((prev) => [...prev, { direction: "RIGHT", message: text }]);
      return getOpenAiPrompt({ question: text, uid: uuid });
    },
    onSuccess: (data) => {
      const text = data?.split("data: ")[1]?.trim();
      setMessages((prev) => [...prev, { direction: "LEFT", message: text }]);
    },
    onError: (err) => {
      console.log({ err });
      snackbar((err.data.message || ""));
    }
  });

  useEffect(() => {
    const uuidExist = localStorage.getItem("hollyPills_uuid");
    if (!uuidExist) {
      localStorage.setItem("hollyPills_uuid", uuidv4());
    }
  }, []);


  return (
    <div className="custome_chat">
      {showChatBoat && (
        <div className="chat_screen">
          <div className="chat_header">
            <p>Hi There </p>
            <span>You have a question? Don't worry, Holy is here to help</span>
            <span className="set_icons_cross" onClick={() => setShowChatBoat(false)}>
              <RxCross2 />
            </span>
          </div>
          <div className="chat_content">

            {/* Messages */}
            {
              messages?.map((item, index) => {
                if (item.direction === "RIGHT") {
                  return <div className="reply_text sender_text" key={index}>
                    <div className="common_width">
                      <pre>{item.message}</pre>
                      {/* <img src={chat_user} alt="" /> */}
                    </div>
                  </div>
                } else {
                  return <div className="reply_text reciver_text" key={index}>
                    <div className="common_width">
                      <img src={chat_user} alt="icon" />
                      <pre>{item.message}</pre>
                    </div>
                  </div>
                }
              })
            }

            {/* Loading */}
            {
              openAiMutation.isPending &&
              <div className="reply_text reciver_text">
                <div className="common_width">
                  <img src={profiledrop} alt="icon" />
                  <pre>Thinking...</pre>
                </div>
              </div>
            }

          </div>
          <div className="wrap_input_send">
            <Input
              disabled={openAiMutation.isPending}
              placeholder="Please type your query..." value={text}
              onChange={e => setText(e.target.value)}
              onKeyUp={e => {
                if (e.key === "Enter" && text?.trim().length) {
                  openAiMutation.mutate()
                }
              }}
            />
            <Button onClick={() => {
              if (text?.trim().length) {
                openAiMutation.mutate();
              }
            }} >Send</Button>
          </div>
        </div>
      )}
      <button
        className="chatboat_icon"
        onClick={() => setShowChatBoat(!showChatBoat)}
      >
        <img src={chat_boat_icon} alt="chat-boat-icon" />
      </button>
    </div>
  );
};

export default ChatBoat;
